import './pagination.scss';
import { Icon } from '@rocketmakers/armstrong';
import { Link, navigate } from 'gatsby';
import * as React from 'react';
import { icons } from '../../content/icons';
import { ArrayUtils } from '../../utils/array';
export const Pagination = ({ newUrl, currentPage, totalPages, disabled }) => {
    if (totalPages <= 1) {
        return null;
    }
    return (<div className="pagination" data-disabled={disabled}>
      <div className="pagination-inner">
        <Link to={newUrl(currentPage - 1)} data-hidden={currentPage === 1}>
          <Icon {...icons.left}/>

          <p>Previous Page</p>
        </Link>
        <p>
          page
          <select name="" id="" value={currentPage} onChange={(e) => navigate(newUrl(parseInt(e.currentTarget.value, 10)))}>
            {ArrayUtils.iterate((i) => (<option key={i}>{i + 1}</option>), totalPages)}
          </select>
          of {totalPages}
        </p>

        <Link to={newUrl(currentPage + 1)} data-hidden={currentPage === totalPages}>
          <p>Next Page</p>

          <Icon {...icons.right}/>
        </Link>
      </div>
    </div>);
};
